import { useLayoutEffect, useEffect } from 'react';
import { isBrowser } from './is-browser.mjs';

var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
// module id = wUmA
// module chunks = 0